import {useContext} from 'react'

import Card from './back-components/card'
import BackFields from './back-components/back-fields'

import {AppContext} from '/providers/app-context'

const GoogleBack = ({ backgroundColour, fgColour }) => {

  const {user} = useContext(AppContext)
  
  return (
    <Card backgroundColour={backgroundColour} fgColour={fgColour}>
      <BackFields show={user.preferences.show_standard_items}/>
    </Card>
  )
}

export default GoogleBack